export default __webpack_public_path__ + "static/img2-63cc42255569230e1906016b011f381c.png";